module.exports = __webpack_public_path__ + "img/sqrt-not.32e263a0.svg";